module.exports = __webpack_public_path__ + "img/bosspack_cod.421314b3.png";